<script setup>
import { VueFinalModal } from 'vue-final-modal'
import { useRoute } from 'vue-router'
import { computed, ref } from 'vue'
// import router from '../routes';
import { useReturnToMenu } from '@client/js/composables/useReturnToMenu.js';

const emit = defineEmits(['close']);
// NEW: reset cart dynamically by paths
const { returnToMenu } = useReturnToMenu(emit);

// Create a media condition that targets viewports at least 768px wide
const mediaQuery = window.matchMedia('(min-width: 1280px)');
let contentTransitionDirection = 'vfm-slide-up';
let swipeToCloseDirection = 'down';
if ( mediaQuery.matches ) {
    swipeToCloseDirection = 'right';
    contentTransitionDirection = 'vfm-slide-right';
}

const route = useRoute();
const name = computed(() => route.name );
const modalId = ref('checkoutModal');

// IMPORTANT: another close handler
const handleClose = () => {
    console.log('check checkout close conditions');
    if (['thanks', 'orderpayment'].includes(route.name)) {
        console.log('Clean some data and then close');
        returnToMenu();
    } else {
        console.log('Just close checkout section');
        emit('close');
    }
}
</script>

<template>
  <VueFinalModal
    swipe-to-close="none"
    :click-to-close="true"
    :lock-scroll="true"
    :content-transition="contentTransitionDirection"
    overlay-transition="vfm-fade"
    display-directive="show"
    :class="['vfm__core', 'vfm__core--' + name ]"
    :modal-id="modalId"
  >
  <div class="vfm__content-outer">
    <div class="vfm__content-inner">
        <!-- <button class="vfm__close" type="button" @click="() => { emit('close'); }"></button> -->
        <button class="vfm__close" type="button" @click="handleClose"></button>
        <slot />
    </div>
    </div>
  </VueFinalModal>
</template>

<style lang="scss" scoped>
.vfm {
    &__core {
        inset: 0;
    }
    &__content {
        position: absolute;
        inset: 0;
    }
    &__content-outer {
        position: absolute;
        inset: 0;
        min-height: 100%;
        min-height: 100vh;
        min-height: 100svh;
        overflow: hidden;
    }
    &__content-inner {
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
        inset: 0;
        top: initial;
        bottom: 0;
        border-radius: 1.25rem 1.25rem 0 0;
        overflow-y: scroll;
        height: calc(100vh - 72px);
        height: calc(100svh - 72px);
        max-height: calc(100vh - 1rem);
        max-height: calc(100svh - 1rem);
        width: 100%;
        max-width: 100svw;
        margin: 0;
        margin-top: 72px;
        border-radius: .25rem .25rem 0 0;
        overflow: hidden;

        .vfm__core--paymentoptions & {
            height: auto;
        }

        @media (min-width: 576px) {

            .vfm__core--paymentoptions & {
                height: 100%;
            }

            position: relative;
            bottom: initial;
            top: 0;
            border-radius: 0rem;
            max-width: 36rem;
            margin-left: auto;
            margin-right: 0;
            margin-top: 0;
            height: 100%;

            // fix cart desktop
            max-height: calc(100svh);
            margin-bottom: 0;
        }

        .admin-bar & {
            // margin-top: 72px;
            // height: calc(100vh - 32px);
            // height: calc(100svh - 32px);
        }

    }
}
.vfm {
    &__close {
        position: absolute;
        right: 0.5rem;
        top: 0.5rem;
        z-index: 2;
        width: 2rem;
        height: 2rem;
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 99px;
        overflow: hidden;
        backdrop-filter: blur(10px);
        outline: none;
        padding: 0;
        display: block;
        line-height: 1;
        box-shadow: none;

        &::before,
        &::after {
            content: '';
            display: block;
            width: 75%;
            height: 1px;
            background-color: #828282;
            top: 50%;
            left: 50%;
            transform-origin: center;
            position: absolute;
        }
        &::before {
            transform: translate3d(-50%, -50%, 0) rotate(-45deg);
        }
        &::after {
            transform: translate3d(-50%, -50%, 0) rotate(45deg);
        }
    }
}
</style>